export default __webpack_public_path__ + "static/media/guide07.339afe30.png";